import React from 'react';
import { InformationContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { Forms, Inputs, Displays } from 'components';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import { portalService } from 'apiServices';
import { toast } from 'react-toastify';

class InformationContainer extends React.Component {
  // filterKey ใช้บังคับสร้าง InputFilter ใหม่ตอนกดล้างค่า
  state = { isLoading: true, filterKey: 0 };

  componentDidMount() {
    scrollToTopPageFN();
    setTimeout(() => {
      this.setState({
        isLoading: false,
      });
    }, 300);
  }

  handleFilterKeyword = async (e) => {
    this.setState({
      isLoading: true,
    });
    const userId = (new URLSearchParams(e).get('user_id') || '').trim();
    let res = await portalService.GET_CUSTOMER_BY_USER_ID(
      encodeURIComponent(userId)
    );
    if (res && res.status === 200) {
      toast.success('พบข้อมูล');
      this.setState({
        initialValues: res.data,
        isLoading: false,
      });
    } else {
      toast.error('ไม่พบข้อมูล');
      this.setState({
        isLoading: false,
        initialValues: null,
      });
    }
  };

  // ล้างช่องค้นหาและฟอร์มข้อมูล user ที่ค้นเจอก่อนหน้า
  handleClearFilter = () => {
    this.setState((prevState) => ({
      initialValues: null,
      filterKey: prevState.filterKey + 1,
    }));
  };

  handleSubmit = async (values) => {
    this.setState({
      isBgLoading: true,
    });
    let params = {
      user_id: values.user_id,
      cu_id: values.cu_id,
      firstname: values.firstname,
      lastname: values.lastname,
      phone_number: values.phone_number,
      email: values.email,
      address: values.address,
    };
    let res = await portalService.PUT_CUSTOMER_UPDATE_BY_ADMIN(
      values._id,
      params
    );
    if (res && res.status === 200) {
      toast.success('แก้ไขสำเร็จ');
      this.setState({
        isBgLoading: false,
      });
    } else {
      toast.error(
        res.errCode === 1 ? 'user id มีการใช้งานแล้ว' : 'แก้ไขไม่สำเร็จ'
      );
      this.setState({
        isBgLoading: false,
      });
    }
  };

  render() {
    const { isLoading, initialValues, isBgLoading, filterKey } = this.state;
    return (
      <InformationContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="filter_layout">
          <Inputs.InputFilter
            key={filterKey}
            theme_standard_input_filter
            dataFilter={dataFilter}
            btnLabel="ค้นหา"
            clearLabel="ล้างค่า"
            onQueryFilter={this.handleFilterKeyword}
            onClear={this.handleClearFilter}
            onExport={this.handleExport}
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="334px" />
        ) : (
          <Forms.InformationForm
            key={filterKey}
            initialValues={initialValues}
            onSubmit={this.handleSubmit}
          />
        )}
      </InformationContainerStyled>
    );
  }
}

const dataFilter = [
  {
    accessor: 'user_id',
    length: '311px',
    filter: {
      fieldQuery: 'user_id',
      type: 'text',
      label: 'Select User : ',
      placeholder: 'User ID',
    },
  },
];

export default withRouter(InformationContainer);
